import { Injectable } from '@angular/core';
import { WorkflowDataService } from '@nimmsta/ng-commons-lib/data-access';
import { Mdm } from '../models/mdm';

@Injectable({
  providedIn: 'root',
})
export class MdmService extends WorkflowDataService<Mdm> {
  private static readonly LOCAL_IP_ADDRESS_ADDITIONAL_DATA_KEY = 'localIpAddress';

  protected override get apiEndpoint(): string {
    return '/handheld';
  }

  static parseAdditionalDataOrEmpty(additionalData?: string): Record<string, string> {
    if (!additionalData) {
      return {};
    }

    try {
      return JSON.parse(additionalData) as Record<string, string>;
    } catch {
      return {};
    }
  }

  static getLocalIpAddress(additionalData?: string): string | undefined {
    const value = MdmService.parseAdditionalDataOrEmpty(additionalData)[MdmService.LOCAL_IP_ADDRESS_ADDITIONAL_DATA_KEY];
    return typeof value === 'string' ? value.trim() || undefined : undefined;
  }

  parseVisibleAdditionalData(additionalData?: string): [string, string][] {
    return Object.entries(MdmService.parseAdditionalDataOrEmpty(additionalData))
      .filter(([key]) => key !== MdmService.LOCAL_IP_ADDRESS_ADDITIONAL_DATA_KEY)
      .sort(([left], [right]) => left.localeCompare(right));
  }

  protected override loadedDataTransform(data: Mdm): Mdm {
    const transformedData = super.loadedDataTransform(data);
    transformedData.localIpAddress = MdmService.getLocalIpAddress(transformedData.additionalData);
    return transformedData;
  }
}
